document.addEventListener('DOMContentLoaded', () => {
  // The element that should trigger the chat
  const trigger = document.querySelector('.cta--chatbot');
  
  if (trigger) {
    // Add visual cue that it's clickable
    trigger.style.cursor = 'pointer';
    
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Find the Shopify Inbox web component
      const chatWidget = document.querySelector('inbox-online-store-chat');
      
      if (chatWidget && chatWidget.shadowRoot) {
        // The toggle button is inside the Shadow DOM
        const toggleBtn = chatWidget.shadowRoot.querySelector('button.chat-toggle');
        
        if (toggleBtn) {
          toggleBtn.click();
        } else {
          console.warn('Shopify Chat toggle button not found in shadow DOM.');
        }
      } else {
        console.warn('Shopify Chat widget not found.');
        // Fallback: try to find the button if it's not in shadow DOM (older versions)
        const fallbackBtn = document.querySelector('#ShopifyChat, .chat-toggle');
        if (fallbackBtn) fallbackBtn.click();
      }
    });
  }
});